/**
 * Dashboard 统计 API 服务
 */
import { api, API_PATHS } from './client';
import type { AppRequestData } from './apps';

// 统计数据
export interface DashboardStats {
  totalUsers: number;
  totalCreators: number;
  pendingReviews: number;
  publishedApps: number;
  recentRequests: AppRequestData[];
}

/**
 * 获取仪表板统计数据
 */
export async function getDashboardStats(): Promise<DashboardStats> {
  return api.get<DashboardStats>(API_PATHS.DASHBOARD_STATS);
}
